module.exports = __webpack_public_path__ + "img/AFG.34560df7.svg";